global.bucket='https://julesmoreldata.s3.eu-west-3.amazonaws.com/';
global.cv_fr=`${global.bucket}files/CV_Jules_Morel_Fr.pdf`;
global.cv_eng=`${global.bucket}files/CV_Jules_Morel.pdf`;
global.csrbf=`${global.bucket}files/poisson_csrbf.pdf`;
global.deep=`${global.bucket}files/10.1007_s00371-020-01966-7.pdf`;
global.shaders=`${global.bucket}files/shaders.txt`;